import { render, staticRenderFns } from "./QaplaButton.vue?vue&type=template&id=89781c90&scoped=true&"
import script from "./QaplaButton.vue?vue&type=script&lang=ts&"
export * from "./QaplaButton.vue?vue&type=script&lang=ts&"
import style0 from "./QaplaButton.vue?vue&type=style&index=0&id=89781c90&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89781c90",
  null
  
)

export default component.exports